var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdduser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16643 11.8643C3.83673 11.8643 1 12.3701 1 14.4017C1 16.4333 3.81079 17 7.16643 17C10.5221 17 13.3242 16.4507 13.3242 14.3842C13.3242 12.3177 10.5048 11.8643 7.16643 11.8643Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16679 8.96946C7.9485 8.96946 8.71264 8.7358 9.36261 8.29795C10.0126 7.8601 10.5192 7.23776 10.8183 6.50965C11.1175 5.78153 11.1957 4.98032 11.0432 4.20736C10.8907 3.4344 10.5143 2.72439 9.96153 2.16712C9.40878 1.60984 8.70454 1.23032 7.93785 1.07656C7.17116 0.922813 6.3765 1.00173 5.6543 1.30333C4.93209 1.60492 4.3148 2.11565 3.88051 2.77094C3.44621 3.42622 3.21439 4.19662 3.21439 4.98472V4.98472C3.21212 5.50572 3.31165 6.02211 3.50731 6.50433C3.70296 6.98654 3.99089 7.42512 4.35469 7.79514C4.71849 8.16516 5.15103 8.45936 5.62759 8.66085C6.10415 8.86234 6.61545 8.96718 7.13222 8.96946H7.16679Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2271 6.16188V9.64961",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 7.91447H13.4624",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdduser);
export default __webpack_public_path__ + "static/media/adduser.596330f83fbfc618c764c6c3a98c402c.svg";
export { ForwardRef as ReactComponent };